import React from 'react';
import { Image, StyleSheet, Pressable } from 'react-native';

import OPComponent from '../op_component';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';
import * as ASSETS from '../../../constants/assets';

export default class ActionButton extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };
  }
  render() {
    const props = this.props;
    return (
      <Pressable
        style={[{ paddingVertical: 10, justifyContent: 'center' }, props.style]}
        onPress={props.onPress}
        disabled={!!props.disabled}
        onHoverIn={({ nativeEvent }) => {
          this.setState({ hovered: true });
        }}
        onHoverOut={({ nativeEvent }) => {
          this.setState({ hovered: false });
        }}
        testID={props.testID}
      >
        <Image
          source={props.source}
          style={[
            styles.actionButton,
            props.disabled ? styles.actionButtonDisabled : null,
            props.extraStyle,
            this.state.hovered && !props.disabled ? styles.actionButtonHover : null,
          ]}
        />
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  actionButton: {
    width: 20,
    height: 20,
    marginHorizontal: 8,
  },
  actionButtonDisabled: {
    tintColor: COLOR.textDisabled,
  },
  actionButtonHover: {
    tintColor: COLOR.redOrangeColor,
  },
});
